var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTileEmail = function SvgTileEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.711,
    height: 15.195,
    viewBox: "0 0 19.711 15.195"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049",
    transform: "translate(0.85 0.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M-23460-22473h18.012v13.5H-23460Z",
    transform: "translate(23460 22473.002)",
    fill: "none",
    stroke: "#74757d",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M7.106,7.29.737,1.416A2.3,2.3,0,0,1,0,0H17.846a2.3,2.3,0,0,1-.737,1.416L10.743,7.29a2.728,2.728,0,0,1-3.637,0Z",
    transform: "translate(0.12 0.001)",
    fill: "none",
    stroke: "#74757d",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y1: 6.353,
    x2: 6.548,
    transform: "translate(0.44 6.896)",
    fill: "none",
    stroke: "#74757d",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 7.021,
    y1: 6.353,
    transform: "translate(11.024 6.896)",
    fill: "none",
    stroke: "#74757d",
    strokeWidth: 1.7
  }))));
};
export default SvgTileEmail;